import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './image.css';

const Image = ({ imgUrl, className, alt, ...otherProps }) => (
  <img
    className={classnames([css['ds-card-image'], className])}
    src={imgUrl}
    alt={alt}
    {...otherProps}
  />
);

Image.defaultProps = {
  imgUrl: null,
  alt: '',
  className: '',
};

Image.propTypes = {
  imgUrl: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default Image;
